import Image from "@/components/Image";
import { useResize } from "@/utils/useResize";
import clsx from "clsx";
import { useMotionValue } from "motion/react";
import { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
import { menus, menus_mobile } from "./data";
import { MenuItem } from "./menu-item";
import { AiAgentModal } from "./modals/ModalAIAgent";
import { ModalDefuture } from "./modals/ModalDefuture";
import { ModalQRApp } from "./modals/ModalQRApp";
import { ModalZKStarter } from "./modals/ModalZKStarter";
import { ModalMore } from "./modals/modal-more";
import { MoreFolder } from "./more-folder";
import { MenuActionType, type MenuType } from "./type";

export function MenuDock() {
  const { width } = useResize();
  const [active, setActive] = useState<MenuType | undefined>();
  const mouseX = useMotionValue(null);
  const navigate = useNavigate();

  const handleSelect = useCallback(
    (e?: MenuType) => {
      if (!e) {
        setActive(undefined);
        return;
      }
      if (e.type === MenuActionType.HYPERLINK) {
        if (e.target === "_blank") {
          window.open(e.to, e.target);
        } else {
          navigate(e.to || "/");
        }
        setActive(undefined);
        return;
      }
      if (e && e.key === active?.key) {
        setActive(undefined);
        return;
      }
      setActive(e);
    },
    [active, navigate]
  );

  return (
    <>
      <div className="z-[98] left-0 right-0 bottom-0 h-[96px] p-2 flex flex-row justify-center mb-2 fixed pointer-events-none">
        {width >= 768 ? (
          <div className="bg-white relative py-3 px-1 rounded-2xl h-full flex  items-end pointer-events-auto">
            {menus.map((item, index) => {
              return (
                <div
                  key={`${item.key}-${index}`}
                  className={clsx("flex relative")}
                >
                  <MenuItem
                    activeItem={active}
                    item={item}
                    mouseX={mouseX}
                    onSelect={(e) => {
                      handleSelect(e);
                    }}
                  />
                  <div className="left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 absolute z-10">
                    {item.type === "view-fan" ? (
                      <MoreFolder
                        menuActive={active}
                        onSelect={(e) => {
                          handleSelect(e);
                        }}
                      />
                    ) : null}
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <div className="bg-white relative py-3 px-4 rounded-2xl h-full flex gap-4 items-end pointer-events-auto">
            {menus_mobile.map((item, index) => {
              return (
                <div
                  key={`mobile-${item.key}`}
                  className={clsx("flex relative", {
                    " md:border-r-[1px] border-[#D1D4DC] ": index === 0,
                    " md:border-l-[1px] border-[#D1D4DC] ":
                      index === Object.keys(menus_mobile).length - 1,
                  })}
                >
                  <button
                    type="button"
                    className="relative z-50"
                    data-action={item.dataAction}
                    onClick={() => {
                      handleSelect(item);
                    }}
                  >
                    <Image
                      alt={item.key}
                      src={
                        active?.key === item.key
                          ? item.activeImg || item.img
                          : item.img
                      }
                      className="w-[56px] h-[56px]"
                    />
                  </button>
                  <div className="left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 absolute z-10">
                    {item.type === "view-fan" ? (
                      <MoreFolder
                        menuActive={active}
                        onSelect={(e) => {
                          handleSelect(e);
                        }}
                      />
                    ) : null}
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>

      {active?.key === "menu-mobile" ? (
        <ModalMore
          onSelect={(e) => {
            handleSelect(e);
          }}
          activeItem={active}
        />
      ) : null}

      {active?.key === "wallet" ? (
        <ModalQRApp
          onClose={() => {
            handleSelect(undefined);
          }}
        />
      ) : null}

      {active?.key === "holdstation-defuture" ? (
        <ModalDefuture
          onClose={() => {
            handleSelect(undefined);
          }}
        />
      ) : null}

      {active?.key === "zk-starter" ? (
        <ModalZKStarter
          onClose={() => {
            handleSelect(undefined);
          }}
        />
      ) : null}

      {active?.key === "agent-ai" ? (
        <AiAgentModal
          onClose={() => {
            handleSelect(undefined);
          }}
        />
      ) : null}
    </>
  );
}
